import { useQuery } from "react-query"
import RedemptionService from "~services/RedemptionService"
import { RedemptionFlow } from "~shapes/redemption"

const useRedemptionFlow = (perkCode: string) => {
  const getRedemptionFlow = async (
    perkCode: string
  ): Promise<RedemptionFlow> => {
    return await RedemptionService.getFlow(perkCode)
  }
  return useQuery(
    ["redemptionFlow", perkCode],
    () => getRedemptionFlow(perkCode),
    {
      enabled: false,
      retry: false,
    }
  )
}

export default useRedemptionFlow
